export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'code', label: 'Code', sortable: true },
    { key: 'short_info', label: 'Short Info', sortable: true },
    { key: 'letter_type', label: 'Letter Type', sortable: true },
    { key: 'period', label: 'Period', sortable: true },
    { key: 'from_org', label: 'From Org', sortable: true },
    { key: 'letter_status', label: 'Letter Status', sortable: true },
    { key: 'actions' },
  ]

  return {
    tableColumns,
  }
}
